import { BaseView } from "@nolimitcity/slot-game/bin/core/base/BaseView";
import { Point, BLEND_MODES } from "pixi.js";
import { TimelineMax, TweenLite, Power3, Back, Power0 } from "gsap";
import { ResizeHelper , IDimConfig, LayoutDimData } from "@nolimitcity/slot-game/bin/core/utils/ResizeHelper";
import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { SanGameConfig } from "../../../SanGameConfig";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";
import { Translation } from "@nolimitcity/slot-game/bin/core/translation/Translation";
import { TranslationConfig } from "../../../translation/TranslationConfig";
import { TextStyleOptions } from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import { TextStyleConfig } from "../../../translation/TextStyleConfig";
import { SlotGame } from "@nolimitcity/slot-game/bin/core/SlotGame";
import { MathHelper } from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import { GameResources } from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import { SanEngineManager } from "../../../engine/SanEngineManager";
import { SpinePlayer } from "../../../proto/SpinePlayer";
import { SoundManager } from "../../../resource/sound/SoundManager";
import { SoundConfig } from "../../../SoundConfig";

export function isSprite(value:any):value is PIXI.Sprite {
    return value.anchor !== undefined && value.position != undefined && value.texture != undefined;
}

class StrokeCounter extends PIXI.Container{

    private readonly vert:string = "FS_Intro/Stroke_A";
    private readonly slice:string = "FS_Intro/Stroke_B";

    private tl:TimelineMax = new TimelineMax();

    private startStroke:number = 0;

    public strokeSound:boolean = true;

    constructor(){
        super();

        for(let stroke:number = 0; stroke < 5; stroke++)
            this.addChild(new PIXI.Sprite(GameResources.getTextures(stroke == 4 ? this.slice : this.vert)[0]))
        this.children.forEach((sp: PIXI.DisplayObject, index: number, array: PIXI.DisplayObject[]) => {
            if (isSprite(sp)) {
                sp.anchor.set(0.5);
                const w = (<PIXI.Sprite>this.children[4]).texture.width;
                if (index != 4) {
                    sp.position.x = ((-w / 2) + sp.texture.width) + (sp.texture.width + 20) * index
                }
                sp.blendMode = BLEND_MODES.ADD;
                sp.alpha = 0;
            }
        });


        this.scale.set(0.75);
    }

    public get amount():number{
        return this.children.length;
    }

    public addStroke(val:number):TimelineMax{
        this.tl = Helper.timeLineKiller(this.tl, new TimelineMax());

        for(let i: number = this.startStroke; i < val; i++){
            this.tl.add([
                TweenLite.fromTo(this.children[i], 0.15,{alpha:0},{alpha:1}),
                TweenLite.fromTo(this.children[i].scale, 0.15,{y:0.8},{y:1, ease: Power3.easeOut}),
            ],0)
        }
        this.tl.add(() => {if (this.strokeSound) SoundManager.playSoundEffect(SoundConfig.instance.FS_BLACKBOARD_STROKE)},0)

        this.startStroke = val;
        return this.tl;
    }
}

export class PostCounter extends BaseView {

    public get dim():LayoutDimData{ return ResizeHelper.calcDim(this.PosterDim); };

    private PosterDim:IDimConfig = {
        dimOrientation : {
            landscape :{
                scale:      new Point( 1, 1),
                position:   new Point( 50, 40),
                layout :{
                    left:   new Point( 50, 40),
                    right:  new Point( 50, 40)
                }
            },
            portrait :{
                scale:      new Point( 1, 1),
                position:   new Point( 0, -70)
            }
        },
        WIDTH: 1440,
        HEIGHT: 900,
    };

    private static _instance:PostCounter;

    private textTrans:PIXI.Text;
    private textAmm:PIXI.Text;

    private timeline:TimelineMax;
    private timelineStroke:TimelineMax;

    private contStrokes:PIXI.Container = new PIXI.Container();
    private quickClicked:boolean = false;

    private quickSoundPlayed:boolean = false;
    private spineGuy:SpinePlayer;

    private isCop:boolean =  false;

    public static get instance():PostCounter{
        return this._instance;
    }

    public set QuickClicked(val:boolean){
        this.quickClicked = val;
    }

    constructor(){
        super();
        PostCounter._instance = this;
        StageManager.getLayer(SanGameConfig.instance.LAYERS.POSTER.name).addChild(this);
    };

    protected initAnimations():void{

        this.spineGuy = this.addChild(new SpinePlayer("fs_Intro_Screen"));
        this.spineGuy.position.set(360,300);
        this.spineGuy.scale.set(1.5,1.5);

        this.addChild(this.contStrokes);
        this.contStrokes.position.set(360, 370);
        this.contStrokes.scale.set(0.5,0.5)

        this.textTrans = this.createText(Translation.translate(TranslationConfig.FREESPINS_LEFT), TextStyleConfig.TOTAL_WIN);
        this.textTrans.position.y = 200;
        this.textAmm = this.createText("4", TextStyleConfig.FS_POSTER_COUNTER);
        this.textAmm.position.y = 360;
        this.textAmm.alpha = 0;

        this._hasInit = true;
    }



    public removeStrokers():void{
        this.quickSoundPlayed = false;
        this.quickClicked = false;

        this.contStrokes.removeChildren().forEach(s => s.destroy());
    }

    public strokeDrawDurr(val:number):number { return val * 0.15;}

    public Stroker(val:number):TimelineMax{

        const startVal:number = this.getAmount;
        const endVal:number = startVal + val;

        if(this.quickClicked && !this.quickSoundPlayed ){
            this.quickSoundPlayed = true;
            SoundManager.playSoundEffect(SoundConfig.instance.FS_BLACKBOARD_STROKE);
        }

        while(this.contStrokes.children.length*5 < endVal){
            const stC:StrokeCounter = new StrokeCounter();
            switch(this.contStrokes.children.length){
                case 0:
                    stC.position.set(-160,55);
                    break;
                case 1:
                    stC.position.set(20, 55);
                    break;
                case 2:
                    stC.position.set(180, 55);
                    break;
                case 3:
                    stC.position.set(-160, 210);
                    break;
                case 4:
                    stC.position.set(20, 210);
                    break;
                case 5:
                    stC.position.set(180, 210);
                    break;
            }
            this.contStrokes.addChild(stC);
        }
        this.timelineStroke = Helper.timeLineKiller(this.timelineStroke, new TimelineMax({
            onComplete:() => SlotGame.keypad.setZeroBetSpinCounter(endVal)
        }), true);

        const s1:number = Math.floor(startVal/5);
        const s2:number = Math.floor(endVal/5) - (endVal%5 === 0 ? 1 : 0);
        this.contStrokes.children.forEach(s => (s as StrokeCounter).strokeSound = !this.quickClicked)

        if(s1 != s2){
            this.timelineStroke.add((this.contStrokes.children[s1] as StrokeCounter).addStroke(5))
            for(let k:number = s1+1; k <= s2; k++){
                if(k == s2)this.timelineStroke.add((this.contStrokes.children[k] as StrokeCounter).addStroke(endVal%5 == 0 ? 5 : endVal%5))
                else this.timelineStroke.add((this.contStrokes.children[k] as StrokeCounter).addStroke(5))
            }
        }
        else this.timelineStroke.add((this.contStrokes.children[s1] as StrokeCounter).addStroke(endVal%5 == 0 ? 5 : endVal%5))


        this.setAmount(endVal);
        return this.timelineStroke;
    }

    private createText(text:string, style:TextStyleOptions):PIXI.Text {
        const textField = new PIXI.Text(text, style);
        textField.style.align = "center";
        textField.anchor.set(0.5, 0.5);
        textField.alpha = 0;
        this.addChild(textField);
        return textField;
    }

    private postType:string = "";
    public setPostType(type:string,amm:number):void{
        if(type[0] === "M") this.postType = "Sym_" + type[1];
        else {
            this.postType = "Wild_X"+amm;
            this.isCop = true;
        }
    }

    public setAmount(amm:number = 0):void{
        this.textAmm.text = amm.toString();
    }

    public get getAmount():number{
        return parseInt(this.textAmm.text);
    }

    public showWildWon():TimelineMax{
        this.onResize();
        this.spineGuy.alpha = 1;
        return this.spineGuy.play({name: this.postType, showOnEnd:true});
    }


    public getWildDurr():number{
        return this.spineGuy.fetchDuration(this.postType)
    }

    public showDude(value:boolean):TimelineMax{
        const tl:TimelineMax = new TimelineMax();

        const toDestPosY:number = 360;
        const fromDestPosY:number = 440;

        if(value){
            this.onResize();
            this.spineGuy.alpha = 1;
            if(this.postType[0] === "S"){
                this.spineGuy.scale.set(1.5,1.5);
                tl.add(this.spineGuy.play({name: this.postType, showOnEnd:true}));
                tl.add(() => SoundManager.playSoundEffect(SoundConfig.instance.FS_CHAR_IN),0.1)
            }else{
                tl.add(this.spineGuy.play({name: "Wild_Transform", showOnEnd:true}));
                tl.add(() => SoundManager.playSoundEffect(SoundConfig.instance.FS_POLICE_SWITCH),0.1)
            }
        }
        else{
            tl.fromTo(this.spineGuy,  0.5,{alpha: value ? 0 : 1 },{alpha: value ? 1 : 0},0);
            tl.to(this.spineGuy.position,  0.5, {y: value ? toDestPosY: fromDestPosY},0);
        }
        return tl;
    }

    public playShow():TimelineMax{

        if(!this._hasInit) this.initAnimations();

        this.textTrans.scale.set(1);
        this.textTrans.text = Translation.translate(TranslationConfig.FREESPINS);
        this.contStrokes.alpha = 1;
        this.timeline = Helper.timeLineKiller(this.timeline, new TimelineMax());
        this.textTrans.y = 320;
        this.textAmm.alpha = 0;
        this.timeline.add([
            this.showDude(true),
            TweenLite.fromTo(this.textTrans,0.35,{alpha:0},{alpha:1}),
            TweenLite.fromTo(this.textTrans.position,0.35,{x:200},{x:360}),
        ]);
        return this.timeline;
    }

    public playCount(amm:number = 0):TimelineMax{

        this.timeline = Helper.timeLineKiller(this.timeline, new TimelineMax(),true);

        const countAmm:number = Math.abs(amm);
        const startValue:number = this.getAmount;

        let stepVal:number = startValue;
        for(let i=0; i < countAmm;i++){
            const showVal:string = (stepVal + (amm >= 0 ? 1 : -1)).toString();
            const countTimer:number = (i*0.2);
            this.timeline.add(() => {
                this.textAmm.text = showVal;
                SlotGame.keypad.setZeroBetSpinCounter(parseInt(showVal));
            }, countTimer );
            this.timeline.to(this.textAmm.scale,0.1,{x:1.15,y:1.15}, countTimer );
            this.timeline.to(this.textAmm.scale,0.1,{x:1,y:1}, countTimer-0.1 );
            stepVal += (amm >= 0 ? 1 : -1);
        }
        return this.timeline;
    }

    public playResultFS():TimelineMax{
        this.timeline = Helper.timeLineKiller(this.timeline, new TimelineMax({
            onUpdate:() => {
                this.textAmm.y = ResizeHelper.IsLandscape() ? this.isCop ? 510 : 480 : this.isCop ? 500 : 460;
            },
            onComplete: () => { this.removeStrokers(); this.isCop = false; }
        }));

        this.textAmm.x = 360;

        for(let i:number = 0; i < this.contStrokes.children.length;i++){
            this.timeline.add([
                TweenLite.to(this.contStrokes.children[i].position,0.5,{x:15,y:100}),
                TweenLite.to(this.contStrokes.children[i].scale,0.5,{x:0,y:0})
            ],0);
        }
        this.timeline.add([
            TweenLite.fromTo(this.textAmm.scale,0.35,{x:0,y:0},{x:1,y:1,ease:Back.easeOut.config(1.5)}),
            TweenLite.fromTo(this.textAmm,0.35,{alpha:0},{alpha:1}),
            () => SoundManager.playSoundEffect(SoundConfig.instance.FS_TOTAL_SPINS)
        ],"-=0.25");
        return this.timeline;
    }

    public playEnd():TimelineMax{
        this.timeline = Helper.timeLineKiller(this.timeline, new TimelineMax({ onComplete:() => {
                this.textAmm.y = 360;
                this.isCop = false;
            }}));
        this.timeline.add([
            this.showDude(false),
            TweenLite.to(this.textTrans,0.25,{alpha:0}),
            TweenLite.to(this.textAmm,0.25,{alpha:0})
        ])
        return this.timeline;
    }

    public play(amm:number = 0,from?:number):TimelineMax{

        if(!this._hasInit) this.initAnimations();

        this.textTrans.text = Translation.translate(TranslationConfig.FREESPINS_LEFT);

        if(from != undefined) this.textAmm.text = from.toString();

        this.textTrans.y = 200;

        const countAmm:number = Math.abs(amm);
        const startValue:number = parseInt(this.textAmm.text);

        this.timeline = Helper.timeLineKiller(this.timeline, new TimelineMax());

        const totalTickDurr:number = (countAmm*0.2);
        const moveTime:number = 0.8 + totalTickDurr;


        if(startValue != 0 || amm > 0){
            this.textTrans.scale.set(1,1);
            this.textTrans.scale = MathHelper.pointMul(<PIXI.Point>this.textTrans.scale, 600/this.textTrans.width);

            this.timeline.add([
                TweenLite.fromTo(this.textTrans,0.35,{alpha:0},{alpha:1}),
                TweenLite.fromTo(this.textAmm,0.35,{alpha:0},{alpha:1}),

                TweenLite.fromTo(this.textTrans.position,0.35,{x:260},{x:340,ease:Power0.easeNone}),
                TweenLite.fromTo(this.textAmm.position,0.35,{x:460},{x:380,ease:Power0.easeNone})
            ])

            const startMoveTime = this.timeline.add([
                TweenLite.to(this.textTrans.position,moveTime,{x:370}),
                TweenLite.to(this.textAmm.position,moveTime,{x:350})
            ]).duration() - (moveTime-totalTickDurr);

            let stepVal:number = startValue;
            for(let i=0; i < countAmm;i++){
                const showVal:string = (stepVal + (amm >= 0 ? 1 : -1)).toString();
                const countTimer:number = startMoveTime + (i*0.2);

                this.timeline.add(() => {
                    this.textAmm.text = showVal;
                    SlotGame.keypad.setZeroBetSpinCounter(parseInt(showVal));
                }, countTimer );
                this.timeline.to(this.textAmm.scale,0.1,{x:1.15,y:1.15}, countTimer );
                this.timeline.to(this.textAmm.scale,0.1,{x:1,y:1}, countTimer-0.1 );

                stepVal += (amm >= 0 ? 1 : -1);
            }

        }else{

            this.textTrans.text = Translation.translate(TranslationConfig.LAST_SPIN);
            this.textTrans.scale.set(1,1)
            if(this.textTrans.width < 500)
                this.textTrans.scale = MathHelper.pointMul(<PIXI.Point>this.textTrans.scale,1.35);
            else{
                this.textTrans.scale = MathHelper.pointMul(<PIXI.Point>this.textTrans.scale, 500/this.textTrans.width);
            }

            this.timeline.add([
                TweenLite.fromTo(this.textTrans,0.35,{alpha:0},{alpha:1}),
                TweenLite.fromTo(this.textTrans.position,0.35,{x:260},{x:340}),
            ])

            this.timeline.add([
                TweenLite.to(this.textTrans.position,moveTime*1.5,{x:380}),
            ]).duration() - (moveTime*1.5-totalTickDurr);
        }

        this.timeline.add([
            TweenLite.to(this.textTrans,0.25,{alpha:0}),
            TweenLite.to(this.textAmm,0.25,{alpha:0}),
        ],"-=" + 0.15)


        return this.timeline;
    }

    protected onResize(){
        this.position = this.dim.position;
        this.scale = SanEngineManager.dim.scale;

        this.spineGuy.position.set(360, ResizeHelper.IsLandscape() ? 300 : 280);
        this.contStrokes.position.set(360,  ResizeHelper.IsLandscape() ? this.isCop ? 410 : 400 : this.isCop ? 400 : 380);
    }
}